import { Controller } from '@hotwired/stimulus';

export default class extends Controller {
  static targets = ['clientType', 'sireneSection', 'siretSection', 'nameInput'];

  connect() {
    this.toggle();
  }

  toggle() {
    const isParticulier = this.clientTypeTarget.value === 'particulier';

    // Hide/show SIRET field
    this.siretSectionTarget.classList.toggle('hidden', isParticulier);

    // Disable typeahead search for particulier (uses sirene-typeahead's disabled value)
    this.sireneSectionTarget.dataset.sireneTypeaheadDisabledValue = isParticulier;

    // Swap placeholder to match context
    this.nameInputTarget.placeholder = isParticulier
      ? 'Nom du client'
      : 'Rechercher une entreprise...';

    // Clear stale SIRET data when switching to particulier
    if (isParticulier) {
      this.clearSiretData();
    }
  }

  clearSiretData() {
    // Clear hidden + visible SIRET inputs
    const hiddenSiret = this.siretSectionTarget.querySelector('input[type="hidden"]');
    const visibleSiret = this.siretSectionTarget.querySelector('input[type="text"]');
    if (hiddenSiret) hiddenSiret.value = '';
    if (visibleSiret) visibleSiret.value = '';

    // Dismiss any sirene-lookup preview card
    const previewTarget = this.siretSectionTarget.querySelector(
      '[data-sirene-lookup-target="preview"]'
    );
    if (previewTarget) {
      previewTarget.classList.add('hidden');
      previewTarget.textContent = '';
    }
  }
}
